import React from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { saveUserSetting } from 'reducers/UserSettingsReducer';
import { notify } from 'reducers/NotifierReducer';
import { RMSSwitch } from '../../../shared/components/form-controls';
import { RMSButton } from '../../../shared/components/buttons';
import {
  NOTIFICATION_PREFS,
  buildDefaultNotificationValues,
} from '../../constants/evidencePreferencesConstants';

const NotificationPreferencesSection = () => {
  const dispatch = useDispatch();
  const evidencePreferenceSetting = useSelector(
    (state) => state.userSettings.evidencePreferenceSetting
  );

  const methods = useForm({
    mode: 'onChange',
    defaultValues: evidencePreferenceSetting?.notifications || buildDefaultNotificationValues(),
  });

  const handleSave = methods.handleSubmit((values) => {
    dispatch(
      saveUserSetting('evidencePreferenceSetting', {
        ...evidencePreferenceSetting,
        notifications: values,
      })
    );
    dispatch(notify('Notification preferences saved', 'success'));
    methods.reset(values);
  });

  return (
    <div className="ev-pref-card">
      <div className="ev-pref-card__body">
        <div className="ev-pref-card__title">Email Notification Preferences</div>
        <div className="ev-pref-card__subtitle ev-pref-card__subtitle--block">
          Choose which email notifications you receive when your evidence items are involved in
          transactions.
        </div>

        <FormProvider {...methods}>
          <div className="ev-pref-notify-list">
            {NOTIFICATION_PREFS.map((item) => (
              <div key={item.key} className="ev-pref-notify-row">
                <div>
                  <div className="ev-pref-notify-row__label">{item.label}</div>
                  <div className="ev-pref-notify-row__desc">{item.desc}</div>
                </div>
                <RMSSwitch name={item.key} label="" />
              </div>
            ))}
          </div>
        </FormProvider>

        <div className="ev-pref-notify-footer">
          <span className="ev-pref-notify-footer-desc">
            Notifications require a valid email address in PTS.
          </span>
          <RMSButton
            label="Save"
            variant="contained"
            className="ev-pref-notify-btn"
            size="small"
            disabled={!methods.formState.isDirty}
            onClick={handleSave}
          />
        </div>
      </div>
    </div>
  );
};

export default NotificationPreferencesSection;
